module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a3a641587a3c797ca626badeb2748885.svg";